import {
    CREATE_TRANSFER_REQUEST,
    CREATE_TRANSFER_SUCCESS,
    CREATE_TRANSFER_ERROR,
} from "../actions/types";



export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {


        case CREATE_TRANSFER_REQUEST:
            return {
                loading: true,
            };
        case CREATE_TRANSFER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case CREATE_TRANSFER_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        default:
            return state;
    }
}
